import Vue from 'vue'

import Router from 'vue-router';
import Home from '@/containers/Home';
import VideoSI from '@/containers/VideoSI';
import VideoNO from '@/containers/VideoNO';
// import Macario from '@/containers/Macario';

import VueObserveVisibility from 'vue-observe-visibility'
import VueScrollTo from 'vue-scrollto'

Vue.use(Router)
Vue.use(VueObserveVisibility)
Vue.use(VueScrollTo)

//export default new Router({
const router = new Router({
  mode: 'history',
  base: '/tecate0.0/',
  routes: [
    {
      path: '/VideoSi',
      name: 'VideoSI',
      components: {
        default: VideoSI
      },
    },
    {
      path: '/VideoNo',
      name: 'VideoNO',
      components: {
        default: VideoNO
      },
    },
    // {
    //   path: '/macario',
    //   name: 'Macario',
    //   components: {
    //     default: Macario
    //   },
    // },
    {
      path: '/:id',
      name: 'Routes',
      components: {
        default: Home,
      },
    },
    {
      path: '/',
      name: 'Home',
      component: Home
    },
  ],
})

// router.beforeEach((to, from, next) => {
//   if (!hasQueryParams(to) && hasQueryParams(from)) {
//       next({name: to.name, query: from.query});
//  } else {
//    next()
//  }
// })
router.beforeEach((to, from, next) => {
  if (!hasQueryParams(to) && hasQueryParams(from)) {
    // Solo redirigir si la ruta no cambia (para evitar conflictos)
    if (to.fullPath === from.path) {
      next({ name: to.name, params: to.params, query: from.query });
      return;
    }
  }
  next();
});

function hasQueryParams(route) {
  return !!Object.keys(route.query).length
}

export default router
